import { useQuery } from "@tanstack/react-query";
import { Button } from "@/design-system/components/ui";
import { documentsApi } from "@/api/documents";
import { useDateFormatter } from "@/utils/datetime";

interface Props {
  documentId: string;
}

/** DMS v1.0 §5f — compact version history drawer shown in the detail pane. */
export function VersionHistoryPanel({ documentId }: Props) {
  const query = useQuery({
    queryKey: ["dms", "versions", documentId],
    queryFn: () => documentsApi.versions(documentId),
  });
  const { dateTime } = useDateFormatter();

  const versions = query.data ?? [];
  if (versions.length <= 1) {
    return null;
  }

  return (
    <div className="mt-space-3 border-t border-border-light pt-space-3">
      <h5 className="font-display font-bold text-label uppercase tracking-label text-gray-mid m-0 mb-space-2">
        Version history
      </h5>
      <ul className="flex flex-col gap-space-2">
        {versions.map((v) => (
          <li
            key={v.id}
            className="flex items-center justify-between gap-space-2 text-small"
          >
            <div>
              <span className="font-semibold">v{v.version}</span>
              <span className="text-gray-mid">
                {" "}
                · {dateTime(v.createdAt)}
              </span>
            </div>
            <Button
              variant="tertiary"
              size="sm"
              onClick={async () => {
                const res = await documentsApi.download(v.id);
                window.open(res.sasUrl, "_blank", "noopener");
              }}
            >
              Download
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
